<template>
  <div class="rootTable">
    <div style="background-color: #d20e2b;margin-top: 40px" v-if="showCondition">
      <header class="mint-header is-fixed" style="border-bottom: 1px solid gainsboro;background: white;">
        <div style="float: left;margin-right: 1rem;margin-top: 0.4rem"><span style="color: black;">{{
            currentDate
          }}</span></div>
        <div style="float: left;margin-top: 0.3rem">
          <img src="../../../assets/images/32/calendar.png"
               style="margin-right:20px ;padding: 0;" height="20"
               width="20" @click="openDatePicker"
               slot="icon" alt="">
        </div>
        <div style="width: 30rem;height: 32px" class="mint-search searchstyle">
          <div class="mint-searchbar" style="padding: 0">
            <div class="mint-searchbar-inner">
              <i class="mintui mintui-search"/>
              <input type="search" placeholder="关键字搜索" class="mint-searchbar-core" style="color: black" v-model.trim="searchKey"/>
              <a class="mint-searchbar-cancel" style="display: none;">取消</a>
            </div>
            <div class="mint-search-list" style="display: none;">
              <div class="mint-search-list-warp"/>
            </div>
          </div>
        </div>
        <div style="float: left;">
          <img src="../../../assets/images/32/search.png" @click="SearchHistoryEvents"
               style="margin-right:20px ;padding: 0;margin-top: 0.5rem" height="20"
               width="20"
               slot="icon" alt="">
        </div>
      </header>
    </div>
    <ul :style="{'margin-top': showCondition?'90px':'50px'}">
      <li v-for="item in eventsList" :key="item.lSSJNM">
        <div class="itemRootDiv" @click="details(item.nR)">
          <div>
            <img src="../../../assets/images/32/event.png" v-if="item.type.toString() === 'normal'" alt="">
            <img src="../../../assets/images/32/birth.png" v-if="item.type.toString() === 'birth'" alt="">
            <img src="../../../assets/images/32/death.png" v-if="item.type.toString() === 'death'" alt="">
          </div>
          <div>
            <div>
              <Span style="color: #2986de">{{ item.sJN }}-{{ item.sJY }}-{{ item.sJR }}</Span>
              <img src="../../../assets/images/16/image.png" alt="" v-if="item.nR.includes('<img')">
            </div>
            <div>
              <Span :style="{'color':item.isSameDay?'red':'black'}">{{ item.bT }}</Span>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div class="empty-div" v-if="showEmptyImage">
      <img src="../../../assets/images/no_data.png" alt=""/>
    </div>
    <DatetimePicker
        ref="date_picker"
        type="date"
        :startDate="startDate"
        :endDate="endDate"
        year-format="{value} 年"
        month-format="{value} 月"
        date-format="{value} 日"
        v-model="tempDate" @confirm="DateConfirm">
    </DatetimePicker>
  </div>
</template>

<script>
import {DatetimePicker, Indicator} from "mint-ui";

export default {
  name: "HistoricalEvent",
  components: {
    DatetimePicker
  },
  data() {
    return {
      showEmptyImage: false,
      eventsList: [],
      searchKey: null,
      event: {
        bT: null,
        lRSJ: null,
        lSSJNM: null,
        nR: null,
        sJN: null,
        sJY: null,
        sJR: null,
        sJLY: null,
        type: null,
        isSameDay: false,
      },
      currentDate: null,
      showCondition: Boolean(Number(localStorage.getItem('showCondition'))),
      tempDate: null,
      startDate: new Date("1901-01-01"),
      endDate: new Date(),
      color: 'black',
      token: localStorage.getItem('token'),
      getEventsUrl: '/api/otherapi/getHistoricalEvent',
      getEventByDatesUrl: '/api/otherapi/getHistoricalEventByDate',
      SearchHistoryEventsUrl: '/api/otherapi/SearchHistoryEvents',
    }
  },
  mounted() {
    if (this.$route.params.csrqnm !== undefined) {
      this.getEvents(this.$route.params.csrqnm)
    } else if (this.$route.params.year !== undefined && this.$route.params.month !== undefined && this.$route.params.day !== undefined) {
      this.currentDate = this.$route.params.year + '-' + this.formatTen(this.$route.params.month) + '-' + this.formatTen(this.$route.params.day)
      this.getEventsbydate(this.$route.params.year, this.$route.params.month, this.$route.params.day)
    } else {
      this.eventsList = JSON.parse(localStorage.getItem('event_temp'))
      this.currentDate = localStorage.getItem('event_time_temp')
    }
  },
  methods: {
    //更改时间格式
    formatTen(num) {
      return num > 9 ? (num + "") : ("0" + num);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return year + '-' + this.formatTen(month) + '-' + this.formatTen(day);
    },
    DateConfirm() {
      this.currentDate = this.formatDate(this.tempDate)
      this.getEventsbydate(this.tempDate.getFullYear(), this.tempDate.getMonth() + 1, this.tempDate.getDate())
    },
    details(val) {
      this.$router.push({name: 'm_historical_event_details', params: {content: val}})
    },
    openDatePicker() {
      if (this.currentDate != null)
        this.tempDate = new Date(this.currentDate)
      else
        this.tempDate = new Date("1990-01-02")
      this.$refs.date_picker.open();
    },
    getEvents(csrqnm) {
      Indicator.open({
        text: '数据加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      this.$ajax({
        method: 'get',
        url: this.getEventsUrl,
        params: {csrqnm: csrqnm},
        headers: {token: this.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        that.eventsList = response.data['responseData']
        if (that.eventsList.length > 0) {
          localStorage.setItem('event_temp', JSON.stringify(that.eventsList))
          localStorage.setItem('event_time_temp', this.currentDate)
          that.showEmptyImage = false
        } else
          that.showEmptyImage = true
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    SearchHistoryEvents() {
      let that = this
      if (!that.searchKey) {
        return
      }
      Indicator.open({
        text: '数据加载中...',
        spinnerType: 'fading-circle'
      });
      this.$ajax({
        method: 'get',
        url: this.SearchHistoryEventsUrl,
        params: {keywords: that.searchKey},
        headers: {token: this.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        that.eventsList = response.data['responseData']
        if (that.eventsList.length > 0) {
          localStorage.setItem('event_temp', JSON.stringify(that.eventsList))
          localStorage.setItem('event_time_temp', this.currentDate)
          that.showEmptyImage = false
        } else
          that.showEmptyImage = true
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    getEventsbydate(year, month, day) {
      Indicator.open({
        text: '数据加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      this.$ajax({
        method: 'get',
        url: this.getEventByDatesUrl,
        params: {year: year, month: month, day: day},
        headers: {token: this.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        that.eventsList = response.data['responseData']
        if (that.eventsList.length > 0) {
          localStorage.setItem('event_temp', JSON.stringify(that.eventsList))
          localStorage.setItem('event_time_temp', this.currentDate)
          that.showEmptyImage = false
        } else
          that.showEmptyImage = true
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.rootTable {
  margin-top: -2.5rem;
  width: 100%;
  height: 100%;
  text-align: left;

  ul {
    list-style-type: none;
    margin: 3rem 0 0 0;

    li {
      height: auto;
      //margin-left: -2.5rem;
      margin-bottom: 0.8rem;

      .itemRootDiv {
        border-bottom: 0.5px solid lightgrey;
        display: flex;
        align-items: center;
      }
    }
  }

  span {
    font-size: 1rem;
  }
}

.empty-div {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate3d(-50%, -50%, 0);
}
</style>
